import React from "react";
import PageHeader from "src/components/pageHeader";
import usePagination from "src/customHooks/usePagination";
import Pagination from "src/components/pagination";
import { Navigate } from "react-router-dom";
import PageLoading from "src/components/pageLoading";
import { useCountKarmaExchangesQuery, useGetKarmaExchangesQuery, PopulatedRewardExchange } from "../karma-exchanges.service";
import KarmaExchangesTable from "../components/karma-exchanges-table";
import KarmaExchangesTableSkeleton from "../components/karma-exchanges-skeleton";
// import { seedKarmaExchangesData } from "../utils/seed-karma-exchanges";

const KarmaExchangesPage = () => {
  // useEffect(() => {
  //   seedKarmaExchangesData();
  // }, []);

  const { data, numberOfPages, currentPage, next, prev, isSuccess, isError, isLoading, isFetching } = usePagination<PopulatedRewardExchange>({
    useGetDataQuery: useGetKarmaExchangesQuery,
    useCountData: useCountKarmaExchangesQuery,
  });

  return isSuccess ? (
    <div className="page_container space-y-4">
      <PageHeader text="Karma Exchanges" />
      {isLoading || isFetching ? (
        <div className="mb-6 overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-sm">
          <table className="min-w-full divide-y divide-gray-200 text-sm text-slate-700">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Exchange ID</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Reward Name</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Username</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Amount</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Created</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Provider</th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">Status</th>
                <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide">Action</th>
              </tr>
            </thead>
            <tbody>
              <KarmaExchangesTableSkeleton rows={10} />
            </tbody>
          </table>
        </div>
      ) : (
        <KarmaExchangesTable exchanges={data || []} />
      )}
      <Pagination numberOfPages={numberOfPages} currentPage={currentPage} prev={prev} next={next} isLoading={isLoading || isFetching} />
    </div>
  ) : isError ? (
    <Navigate to="/505" />
  ) : (
    <PageLoading />
  );
};

export default KarmaExchangesPage;
